  
export default function Splittext(str,txtsplit) {
    let res = str.split(txtsplit);
    //console.log("date" + date); 
    return res
    
}


